// extracted by mini-css-extract-plugin
export default {"root":"LWH9pXbNPcpCytE8Nik2","list":"m7_zkkbGidmm4uzP89pT","tab":"F6w467PFc2Vnan6kotAT"};